import {
  CallbackObserver,
  combineCallbackObserver
} from "#booster/classes/CallbackObserver";
function getDefaultConfig() {
  return {
    timing: {
      fcp: 500,
      dcl: 800
    }
  };
}
let customConfig = getDefaultConfig();
export function setup(config = getDefaultConfig()) {
  customConfig = {
    timing: {
      ...customConfig.timing,
      ...config.timing || {}
    }
  };
  customConfig = {
    ...customConfig,
    ...config
  };
}
export function hasSufficientPerformance() {
  return hasSufficientDownloadPerformance() && !import.meta.server;
}
export function hasSufficientDownloadPerformance() {
  if (window.performance && customConfig.timing) {
    const paint = performance.getEntriesByName("first-contentful-paint");
    const resources = performance.getEntriesByType("resource");
    if (paint.length) {
      return paint[0].startTime < customConfig.timing.fcp;
    } else if (resources.length) {
      return resources.reduce((result, resource) => {
        if (!result || result < resource.startTime + resource.duration) {
          result = resource.startTime + resource.duration;
        }
        return result;
      }, 0) < customConfig.timing.dcl;
    }
  }
  return false;
}
let startTime;
function resolveTimes(maxTime, threshold, resolve, reject) {
  const buffer = new ValueBuffer(10, threshold / 2);
  return ([raf, idle]) => {
    const time = window.performance.now() - startTime;
    const value = idle / raf;
    if (value <= 1) {
      buffer.add(value);
    }
    if (buffer.avg <= 1 && buffer.avg > threshold) {
      resolve(true);
    } else if (time >= maxTime) {
      reject(false);
    }
  };
}
export async function run(options = {}) {
  if ("requestIdleCallback" in window) {
    const maxTime = options.maxTime || 1e3;
    const threshold = options.threshold || 0.65;
    const fpsObserver = new CallbackObserver(rafTime);
    const idleObserver = new CallbackObserver(idleTime);
    return new Promise((resolve, reject) => {
      startTime = window.performance.now();
      combineCallbackObserver(
        resolveTimes(maxTime, threshold, resolve, reject),
        [fpsObserver, idleObserver]
      );
    }).finally(() => {
      fpsObserver.destroy();
      idleObserver.destroy();
    });
  }
}
function rafTime(fn) {
  let prevTime = performance.now();
  const loop = () => {
    const time = performance.now();
    const offset = time - prevTime;
    prevTime = time;
    const running = fn(offset);
    if (running) {
      requestAnimationFrame(loop);
    }
  };
  requestAnimationFrame(loop);
}
function idleTime(callback) {
  const loop = (deadline) => {
    const running = callback(deadline.timeRemaining());
    if (running) {
      window.requestIdleCallback(loop);
    }
  };
  window.requestIdleCallback(loop);
}
class ValueBuffer {
  list;
  index = 0;
  constructor(count = 10, defaultValue = 0) {
    this.list = Array(count).fill(defaultValue);
  }
  add(value) {
    this.list[this.index] = value;
    this.index = (this.index + 1) % this.list.length;
  }
  get avg() {
    return this.list.reduce((r, v) => r += v, 0) / this.list.length;
  }
}
